module.exports = __webpack_public_path__ + "static/img/member260119EN.fec00b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member260119EN.jpg
// module id = va5I
// module chunks = 1